var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgOutlineFilterList = function SvgOutlineFilterList(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.033 15.9h3.934v-1.967H8.033V15.9zM1.15 4.1v1.967h17.7V4.1H1.15zm2.95 6.883h11.8V9.017H4.1v1.966z",
    fill: "currentColor",
    className: "layer"
  })));
};
export default SvgOutlineFilterList;